import { FC } from 'react';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import LeadsWindowList from '../../modules/leads-windows/components/LeadsWindowList';
import { usePathProps } from '../../modules/user-profile/hooks/usePathProps';

const LeadsWindowsPage: FC = () => {
  const intl = useIntl();
  usePathProps();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'leadsWindows.title' })}
      </PageTitle>
      <div className="row">
        <div className="col-12">
          <LeadsWindowList />
        </div>
      </div>
    </>
  );
};

export { LeadsWindowsPage };
